import React, { useState, useEffect } from 'react';



import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import TestimonialsSection from './components/TestimonialsSection';
import StatsSection from './components/StatsSection';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Add top padding to account for fixed header */}
      <div className="pt-14">
        <HeroSection />
        <ServicesSection />
        <PortfolioSection />
        <TestimonialsSection />
        <StatsSection />
        <BlogSection />
        <Footer />
      </div>
    </div>
  );
};

export default Home;